import React, { useState, useEffect } from 'react';
import { API } from 'aws-amplify';
import './Home.css';

function Home({ signOut, user }) {
  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    fetchUserData();
  }, []);

  const fetchUserData = async () => {
    try {
      const response = await API.get('API', '/users', {});
      setUserData(response);
      setLoading(false);
    } catch (err) {
      console.error('Error fetching user data:', err);
      setError('Error fetching user data. Please try again.');
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="Home">Loading...</div>;
  }

  if (error) {
    return <div className="Home">{error}</div>;
  }

  return (
    <div className="Home">
      <div className="home-container">
        <h1>Welcome, {user.attributes.email}!</h1>
        <p>You have successfully logged in.</p>
        {userData && (
          <div>
            <h2>User Data from API:</h2>
            <pre>{JSON.stringify(userData, null, 2)}</pre>
          </div>
        )}
        <button className="logout-btn" onClick={signOut}>
          <span>Logout</span>
        </button>
      </div>
    </div>
  );
}

export default Home;